import React, { useState, useMemo } from "react";
import { Link } from "react-router-dom";
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import "./style.css";

import { useGetPendingOrderCRMQuery } from "../../../../store/common/commonApiSlice";
import { getMenuItems } from "./data";


const Hamburger = () => {
    const [sidebar, setSidebar] = useState(false);
    const showSidebar = () => setSidebar(!sidebar);

    const { data } = useGetPendingOrderCRMQuery();
    const showPrepcaConnect = !data?.paymentPending;

    const menuItems = useMemo(() => {
        return getMenuItems({ isPrepcaConnectToshow: showPrepcaConnect });
    }, [showPrepcaConnect]);

    return (
        <div>
            <div className="hamburger">
                <MenuIcon onClick={showSidebar} />
            </div>
            <nav className={sidebar ? 'nav_menu active' : 'nav_menu'}>
                <ul className="nav_menu_items">
                    <li className="nav_bar_toggle">
                        <CloseIcon onClick={showSidebar} />
                    </li>
                    {menuItems.map((item, index) => (
                        <li key={index} className="nav_text" onClick={showSidebar}>
                            {item.external ? (
                                <a
                                    href={item.to}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="link"
                                >
                                    {item.icon}
                                    {item.label}
                                </a>
                            ) : (
                                <Link to={item.to} className="link">
                                    {item.icon}
                                    {item.label}
                                </Link>
                            )}
                        </li>
                    ))}
                </ul>
            </nav>
        </div>
    );
};

export default Hamburger;
